import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';

import { api } from '@/lib/api';

export interface ApiToken {
  id: number;
  name: string;
  created_at: string;
  last_used_at: string | null;
  revoked_at: string | null;
}

export interface ApiTokenCreateResponse {
  token: string;
  record: ApiToken;
}

export function useApiTokens(orgSlug: string | null | undefined) {
  return useQuery<ApiToken[]>({
    queryKey: ['api-tokens', orgSlug],
    queryFn: () => api.get<ApiToken[]>(`/api/orgs/${orgSlug}/api-tokens`),
    enabled: Boolean(orgSlug),
    staleTime: 60_000,
  });
}

export function useMintApiToken(orgSlug: string) {
  const qc = useQueryClient();
  return useMutation<ApiTokenCreateResponse, Error, { name: string }>({
    mutationFn: (input) =>
      api.postJson<ApiTokenCreateResponse>(
        `/api/orgs/${orgSlug}/api-tokens`,
        input,
      ),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ['api-tokens', orgSlug] });
    },
  });
}

export function useRevokeApiToken(orgSlug: string) {
  const qc = useQueryClient();
  return useMutation<void, Error, number>({
    mutationFn: (tokenId) =>
      api.delete<void>(`/api/orgs/${orgSlug}/api-tokens/${tokenId}`),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ['api-tokens', orgSlug] });
    },
  });
}
